import PageHero from '@/components/PageHero'
import SEOHead from '@/components/SEOHead'
import {ChevronDown} from 'lucide-react'
import { useState } from 'react'

const faqs = [
  {
    q: 'What is the difference between ROI and ROAS?',
    a: 'ROAS measures gross revenue generated per ad dollar spent on a specific campaign, while ROI measures overall net profit relative to total business investments (including operational costs and COGS).',
  },
  {
    q: 'What does a ROAS of 3.0x mean?',
    a: 'It means that for every dollar invested in advertising, three dollars of revenue are generated (a 300% return).',
  },
  {
    q: 'What is a break-even ROAS?',
    a: 'It is the point where campaign revenue exactly covers both your ad spend and your product costs, resulting in $0 net profit. Any performance above this point is profitable.',
  },
  {
    q: 'How do I calculate ROAS in Google Sheets?',
    a: 'Use the formula =SUM(Revenue_Cell) / SUM(Ad_Spend_Cell) to divide total revenue by total ad spend for the period you are analyzing.',
  },
  {
    q: 'What counts as a "good" ROAS?',
    a: 'It depends on your margins, but a 4:1 ROAS is a common healthy benchmark for e-commerce, while below 2:1 often signals thin or negative profitability once product costs are included.',
  },
]

function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <div>
      <SEOHead
        title="FAQ"
        description="Answers to common questions about ROAS, ROI, break-even points, and how to calculate advertising performance."
      />
      <PageHero
        eyebrow="Quick answers"
        title="Frequently Asked Questions"
        description="Everything you need to know about ROAS calculations, break-even points, and advertising ROI."
      />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14">
        <div className="space-y-3">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i
            return (
              <div key={i} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-slate-50 transition-colors"
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-slate-900 tracking-tight">{item.q}</span>
                  <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform ${isOpen ? 'rotate-180 text-emerald-600' : ''}`} />
                </button>
                {isOpen ? (
                  <div className="px-5 pb-5 text-slate-600 leading-relaxed text-[15px] border-t border-slate-100 pt-3">{item.a}</div>
                ) : null}
              </div>
            )
          })}
        </div>
      </section>
    </div>
  )
}

export default Faq
